// This store represents a loaded scenario (from an external json file)
import { writable, derived } from 'svelte/store';
function normalizeId(id) {
    return `${'0'.repeat(5 - String(id).length)}${id}`;
}
const dummyScene = {
    metadata: {
        part: 'I',
        chapter: '1'
    },
    dialogNodes: {}
};
export const scene = writable(dummyScene);
export const dialogNodeList = derived(scene, $scene => Object.keys($scene.dialogNodes).map((dnKey) => {
    var _a;
    return ({
        id: dnKey,
        text: `#${normalizeId(dnKey)} - ${((_a = $scene.dialogNodes[dnKey].text.fr) === null || _a === void 0 ? void 0 : _a.m) || $scene.dialogNodes[dnKey].text.fr}`,
    });
}));
